import { RouteComponentProps } from '@reach/router'
import { Link } from 'gatsby'
import { DashboardTitle } from './DashboardTitleContext'
import { MatchedResults } from './Results'

const ArchivedResultQueue = (props: RouteComponentProps) => {
  return (
    <div className="container">
      <DashboardTitle title="Archived Results" />

      <MatchedResults
        queueName="ArchivedResults"
        titleFn={(qty) => (
          <>
            <strong>{qty}</strong> archived results
            <br />
            <Link className="is-size-6 has-text-weight-normal" to="/dashboard/results">
              Normal Results Queue
            </Link>
          </>
        )}
      />
    </div>
  )
}

export default ArchivedResultQueue
